/* DC reviews: Yotpo's reviews and questions drawn as a summary card over a masonry of review cards (Pablo's reference:
   bestfriendsbysheri.com, 2026-10-14). Reads Yotpo's public storefront API, the same one its own widget calls.
   Mount: <div class="dcr" data-store="<yotpo app key>" data-product="<shopify product id>"></div> */
(() => {
  const API = 'https://api-cdn.yotpo.com';
  const PER = 50, SHOW = 12;
  const STAR = 'M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6L2.5 9.4l6.6-.8z';

  const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
  const stars = (score, size = 16) => {
    const w = el('span', 'dcr-stars');
    w.setAttribute('role', 'img');
    w.setAttribute('aria-label', `${(Math.round(score * 10) / 10).toString()} out of 5 stars`);
    for (let i = 1; i <= 5; i++) {
      const fill = Math.max(0, Math.min(1, score - i + 1));
      const id = 'dcrg' + Math.random().toString(36).slice(2, 8);
      w.insertAdjacentHTML('beforeend', `<svg width="${size}" height="${size}" viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="${id}"><stop offset="${fill}" stop-color="currentColor"/><stop offset="${fill}" stop-color="#d4d4d4"/></linearGradient></defs><path d="${STAR}" fill="url(#${id})"/></svg>`);
    }
    return w;
  };
  // Yotpo stores some text HTML-escaped (&#x27;) and some with broken UTF-8 quotes (â€™): show both as plain characters.
  // A textarea decodes entities without parsing markup, and the result only ever goes into textContent.
  const dec = (s) => { const t = document.createElement('textarea'); t.innerHTML = s || ''; return t.value.replace(/â€™/g, '’').replace(/â€˜/g, '‘').replace(/â€œ/g, '“').replace(/â€\u009d|â€\x9d/g, '”').replace(/â€”/g, '—').replace(/â€“/g, '–'); };
  const date = (s) => new Date(s.replace(' ', 'T')).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  const initial = (name) => (name || '?').trim().charAt(0).toUpperCase();

  // a block of text clamped to a few lines, with "Show more" only when it actually overflows
  const clamp = (text, cls, lines) => {
    const wrap = el('div', cls);
    const p = el('p', 'dcr-clamp', dec(text).trim());
    p.style.setProperty('--lines', lines);
    const more = el('button', 'dcr-more', 'Show more');
    more.type = 'button';
    more.hidden = true;
    more.addEventListener('click', () => { const open = p.classList.toggle('is-open'); more.textContent = open ? 'Show less' : 'Show more'; root.relayout(); });
    wrap.append(p, more);
    requestAnimationFrame(() => { more.hidden = p.scrollHeight <= p.clientHeight + 2; });
    return wrap;
  };

  let root;

  function mount(node) {
    const store = node.dataset.store, product = node.dataset.product;
    const base = `${API}/v3/storefront/store/${store}/product/${product}`;
    const state = { all: null, first: [], total: 0, dist: {}, avg: 0, sort: 'photos', score: 0, shown: SHOW, tab: 'reviews', questions: null, qTotal: 0 };
    node.classList.add('dcr-ready');
    node.innerHTML = '';

    // ---- summary card
    const head = el('div', 'dcr-summary');
    const score = el('div', 'dcr-score');
    const big = el('div', 'dcr-avg');
    const count = el('div', 'dcr-count');
    const write = el('button', 'dcr-write', 'Write a review');
    write.type = 'button';
    score.append(big, el('div', 'dcr-avg-stars'), count, write);
    const bars = el('div', 'dcr-bars');
    const photos = el('div', 'dcr-photos');
    head.append(score, bars, photos);

    // ---- tabs + controls
    const bar = el('div', 'dcr-bar');
    const tabs = el('div', 'dcr-tabs');
    tabs.setAttribute('role', 'tablist');
    const tRev = el('button', 'dcr-tab is-on', 'Reviews');
    const tQ = el('button', 'dcr-tab', 'Questions');
    [tRev, tQ].forEach((t) => { t.type = 'button'; t.setAttribute('role', 'tab'); });
    tabs.append(tRev, tQ);
    const ctl = el('div', 'dcr-ctl');
    const chip = el('button', 'dcr-chip');
    chip.type = 'button';
    chip.hidden = true;
    const sortLabel = el('label', 'dcr-sort');
    const sel = el('select');
    [['photos', 'Photos first'], ['new', 'Newest'], ['high', 'Highest rating'], ['low', 'Lowest rating']].forEach(([v, t]) => { const o = el('option', null, t); o.value = v; sel.append(o); });
    sortLabel.append(el('span', 'dcr-sr', 'Sort reviews'), sel);
    ctl.append(chip, sortLabel);
    bar.append(tabs, ctl);

    const grid = el('div', 'dcr-grid');
    const foot = el('div', 'dcr-foot');
    const moreBtn = el('button', 'dcr-load', 'Show more reviews');
    moreBtn.type = 'button';
    foot.append(moreBtn);
    const status = el('p', 'dcr-status');
    status.setAttribute('aria-live', 'polite');
    node.append(head, bar, status, grid, foot);

    // ---- lightbox
    const box = el('dialog', 'dcr-box');
    const boxImg = el('img');
    const boxClose = el('button', 'dcr-box-x', '×');
    boxClose.type = 'button';
    boxClose.setAttribute('aria-label', 'Close photo');
    const prev = el('button', 'dcr-box-prev', '‹'), next = el('button', 'dcr-box-next', '›');
    prev.setAttribute('aria-label', 'Previous photo');
    next.setAttribute('aria-label', 'Next photo');
    box.append(boxImg, boxClose, prev, next);
    node.append(box);
    let boxList = [], boxAt = 0;
    const showBox = (i) => { boxAt = (i + boxList.length) % boxList.length; boxImg.src = boxList[boxAt].originalUrl; boxImg.alt = boxList[boxAt].alt || 'Customer photo'; prev.hidden = next.hidden = boxList.length < 2; };
    const openBox = (list, i) => { boxList = list; showBox(i); box.showModal(); };
    boxClose.onclick = () => box.close();
    prev.onclick = () => showBox(boxAt - 1);
    next.onclick = () => showBox(boxAt + 1);
    box.addEventListener('click', (e) => { if (e.target === box) box.close(); });

    // ---- masonry: cards go one by one into the shortest column, so they read left to right
    let cols = 0, cards = [];
    const colCount = () => { const w = grid.clientWidth; return w >= 900 ? 3 : w >= 300 ? 2 : 1; };
    const layout = (force) => {
      const n = colCount();
      if (n === cols && !force) return;
      cols = n;
      grid.innerHTML = '';
      const cs = Array.from({ length: n }, () => grid.appendChild(el('div', 'dcr-col')));
      cards.forEach((c) => { cs.reduce((a, b) => (b.offsetHeight < a.offsetHeight ? b : a)).append(c); });
    };
    root = { relayout: () => layout(true) };
    new ResizeObserver(() => layout(false)).observe(grid);

    const reviewCard = (r) => {
      const c = el('article', 'dcr-card');
      const imgs = (r.imagesData || []).map((i) => ({ ...i, alt: `Photo from ${r.user?.displayName || 'a customer'}'s review` }));
      if (imgs.length) {
        const fig = el('button', 'dcr-card-photo');
        fig.type = 'button';
        fig.setAttribute('aria-label', `Open ${imgs.length > 1 ? imgs.length + ' photos' : 'photo'} from this review`);
        const im = el('img');
        im.loading = 'lazy';
        im.src = imgs[0].originalUrl + '&format=webp&width=720';
        im.alt = imgs[0].alt;
        fig.append(im);
        if (imgs.length > 1) fig.append(el('span', 'dcr-plus', `+${imgs.length - 1}`));
        fig.onclick = () => openBox(imgs, 0);
        c.append(fig);
      }
      const body = el('div', 'dcr-card-body');
      const who = el('div', 'dcr-who');
      const name = r.user?.displayName || 'Customer';
      const av = el('span', 'dcr-avatar', initial(name));
      av.setAttribute('aria-hidden', 'true');
      const id = el('div', 'dcr-id');
      id.append(el('span', 'dcr-name', name));
      if (r.verifiedBuyer) id.append(el('span', 'dcr-verified', 'Verified buyer'));
      who.append(av, id, el('time', 'dcr-date', date(r.createdAt)));
      body.append(who, stars(r.score, 16));
      if (r.title && r.title.trim() && dec(r.title).trim() !== dec(r.content).trim()) body.append(el('h3', 'dcr-title', dec(r.title).trim()));
      body.append(clamp(r.content, 'dcr-text', colCount() > 2 ? 7 : 6));
      if (r.comment?.content) {
        const rep = el('div', 'dcr-reply');
        rep.append(el('p', 'dcr-reply-who', `${r.comment.displayName || 'Direct Colors'} replied`), clamp(r.comment.content, 'dcr-reply-text', 4));
        body.append(rep);
      }
      c.append(body);
      return c;
    };

    const questionCard = (q) => {
      const c = el('article', 'dcr-card');
      const body = el('div', 'dcr-card-body');
      const who = el('div', 'dcr-who');
      const name = q.asker?.display_name || 'Customer';
      const av = el('span', 'dcr-avatar', 'Q');
      av.setAttribute('aria-hidden', 'true');
      const id = el('div', 'dcr-id');
      id.append(el('span', 'dcr-name', name));
      who.append(av, id, el('time', 'dcr-date', date(q.created_at)));
      body.append(who, el('h3', 'dcr-title dcr-q', dec(q.content).trim()));
      (q.answers || []).slice(0, 1).forEach((a) => {
        const rep = el('div', 'dcr-reply');
        rep.append(el('p', 'dcr-reply-who', `${a.answerer?.display_name || 'Direct Colors'} answered`), clamp(a.content, 'dcr-reply-text', 6));
        body.append(rep);
      });
      c.append(body);
      return c;
    };

    const order = {
      photos: null, // Yotpo's own order: photos first, then rating and date
      new: (a, b) => b.createdAt.localeCompare(a.createdAt),
      high: (a, b) => b.score - a.score || b.createdAt.localeCompare(a.createdAt),
      low: (a, b) => a.score - b.score || b.createdAt.localeCompare(a.createdAt),
    };
    const list = () => {
      let l = state.all || state.first;
      if (state.score) l = l.filter((r) => r.score === state.score);
      if (order[state.sort]) l = [...l].sort(order[state.sort]);
      return l;
    };

    const render = () => {
      const isRev = state.tab === 'reviews';
      tRev.classList.toggle('is-on', isRev); tQ.classList.toggle('is-on', !isRev);
      tRev.setAttribute('aria-selected', isRev); tQ.setAttribute('aria-selected', !isRev);
      ctl.hidden = !isRev;
      chip.hidden = !state.score;
      chip.textContent = `${state.score} stars only ×`;
      chip.setAttribute('aria-label', `Showing ${state.score}-star reviews. Show all reviews`);
      bars.querySelectorAll('.dcr-row').forEach((b) => b.setAttribute('aria-pressed', +b.dataset.s === state.score));
      let l, total;
      if (isRev) { l = list(); total = state.score ? (state.dist[state.score] || 0) : state.total; }
      else { l = state.questions || []; total = state.qTotal; }
      cards = l.slice(0, state.shown).map(isRev ? reviewCard : questionCard);
      layout(true);
      const left = total - Math.min(state.shown, total);
      foot.hidden = left <= 0;
      moreBtn.textContent = isRev ? 'Show more reviews' : 'Show more questions';
      status.textContent = state.score ? `${total} ${state.score}-star review${total === 1 ? '' : 's'}` : '';
    };

    const fetchJSON = (u) => fetch(u).then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); });
    const loadAll = async () => {
      if (state.all) return;
      const pages = Math.ceil(state.total / PER);
      const rest = await Promise.all(Array.from({ length: pages - 1 }, (_, i) => fetchJSON(`${base}/reviews?page=${i + 2}&perPage=${PER}&sort=images,badge,rating,date`)));
      state.all = state.first.concat(...rest.map((j) => j.reviews));
    };
    const loadQuestions = async () => {
      const per = 100;
      const j = await fetchJSON(`${API}/v1/widget/${store}/products/${product}/questions?page=1&per_page=${per}`);
      state.questions = j.response.questions.filter((q) => (q.answers || []).length);
      state.qTotal = state.questions.length;
    };

    const busy = async (fn) => { node.setAttribute('aria-busy', 'true'); try { await fn(); } catch (e) { status.textContent = 'Reviews could not load. Refresh the page to try again.'; } node.removeAttribute('aria-busy'); };

    sel.onchange = () => busy(async () => { state.sort = sel.value; state.shown = SHOW; if (state.sort !== 'photos') await loadAll(); render(); });
    chip.onclick = () => { state.score = 0; state.shown = SHOW; render(); };
    moreBtn.onclick = () => busy(async () => { state.shown += SHOW; if (state.tab === 'reviews' && state.shown > state.first.length) await loadAll(); render(); });
    tRev.onclick = () => { state.tab = 'reviews'; state.shown = SHOW; render(); };
    tQ.onclick = () => busy(async () => { if (!state.questions) await loadQuestions(); state.tab = 'questions'; state.shown = SHOW; render(); });

    // Write a review: Yotpo's own form, from its widget kept hidden on the page
    write.onclick = () => {
      const y = document.querySelector('.dcr-yotpo .yotpo-new-review-btn, .dcr-yotpo button[class*="write-review"]');
      if (y) y.click();
    };

    busy(async () => {
      const j = await fetchJSON(`${base}/reviews?page=1&perPage=${PER}&sort=images,badge,rating,date`);
      const bl = j.bottomline;
      state.first = j.reviews;
      state.total = bl.totalReview;
      state.dist = bl.starDistribution || {};
      state.avg = bl.averageScore;
      big.textContent = (Math.round(state.avg * 10) / 10).toFixed(1);
      score.querySelector('.dcr-avg-stars').append(stars(state.avg, 20));
      count.textContent = `${state.total.toLocaleString('en-US')} reviews`;
      tRev.textContent = `Reviews (${state.total.toLocaleString('en-US')})`;
      for (let s = 5; s >= 1; s--) {
        const n = state.dist[s] || 0;
        const row = el('button', 'dcr-row');
        row.type = 'button';
        row.dataset.s = s;
        row.disabled = !n;
        row.setAttribute('aria-label', `${s} stars: ${n} reviews. Show only these`);
        const track = el('span', 'dcr-track');
        const fillEl = el('span', 'dcr-fill');
        fillEl.style.width = `${state.total ? (n / state.total) * 100 : 0}%`;
        track.append(fillEl);
        const st = el('span', 'dcr-row-star');
        st.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="${STAR}" fill="currentColor"/></svg>`;
        row.append(el('span', 'dcr-row-s', `${s}`), st, track, el('span', 'dcr-row-n', n.toLocaleString('en-US')));
        row.onclick = () => busy(async () => { state.score = state.score === s ? 0 : s; state.shown = SHOW; await loadAll(); render(); });
        bars.append(row);
      }
      const pics = state.first.flatMap((r) => (r.imagesData || []).map((i) => ({ ...i, alt: `Photo from ${r.user?.displayName || 'a customer'}'s review` })));
      if (pics.length) {
        photos.append(el('p', 'dcr-photos-h', 'Customer photos'));
        const strip = el('div', 'dcr-strip');
        const MAX = 7;
        pics.slice(0, MAX).forEach((p, i) => {
          const b = el('button', 'dcr-thumb');
          b.type = 'button';
          b.setAttribute('aria-label', `Open customer photo ${i + 1} of ${pics.length}`);
          const im = el('img');
          im.loading = 'lazy';
          im.src = p.originalUrl + '&format=webp&width=200&height=200';
          im.alt = '';
          b.append(im);
          if (i === MAX - 1 && pics.length > MAX) b.append(el('span', 'dcr-plus', `+${pics.length - MAX + 1}`));
          b.onclick = () => openBox(pics, i);
          strip.append(b);
        });
        photos.append(strip);
      } else photos.remove();
      fetchJSON(`${API}/v1/widget/${store}/products/${product}/questions?page=1&per_page=1`).then((q) => { const t = q.response.pagination.total.questions; tQ.textContent = `Questions (${t})`; if (!t) tQ.remove(); }).catch(() => tQ.remove());
      render();
    });
  }

  const start = () => document.querySelectorAll('.dcr:not(.dcr-ready)').forEach((n) => {
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); mount(n); } }, { rootMargin: '800px 0px' });
    io.observe(n);
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
